import SkippableDTO from "@/dto/taxation/individual/SkippableDTO";

export default class ValuableDTO<T> extends SkippableDTO {

    public value: T | null = null;

}